import React from "react";
import "./Footer.css";
import { Link } from "react-scroll";
import flogo from "./footer-img/Screenshot_17-12-2024_224833_-removebg-preview (1).png";
import { useNavigate } from "react-router-dom";

const Footer = () => {
    const navigate = useNavigate();

    const productclick = () => {
        navigate("/product");
    };

    return (
        <div className="footer-main" id="footer">
            <div className="footer-content-main">

                {/* ================= LOGO & CONTACT ================= */}
                <div className="footer-logo">
                    <div className="footer-logo-img">
                        <img src={flogo} alt="Aizo Plug Logo" />
                    </div>

                    <div className="footer-logo-content">
                        <p>
                            <i className="fa-solid fa-envelope"></i> info@aizoplug.com
                        </p>
                        <p>
                            <i className="fa-solid fa-phone"></i> +91 8012523333
                        </p>

                        <div className="footer-location-p">
                            <i className="fa-solid fa-location-dot"></i>
                            <p>
                                Aizo Teq Solutions Pvt Ltd, Kadambuzha, Malappuram,
                                Kerala, India – 676553
                            </p>
                        </div>
                    </div>
                </div>

                {/* ================= QUICK LINKS ================= */}
                <div className="footer-quick">
                    <div className="footer-quick-head">
                        <p>Quick Links</p>
                    </div>

                    <div className="footer-quick-content">
                        <p>
                            <Link spy smooth offset={-100} to="homee">
                                Home
                            </Link>
                        </p>

                        <p>
                            <Link spy smooth offset={-100} to="about">
                                About Us
                            </Link>
                        </p>

                        <p>
                            <Link spy smooth offset={-100} to="service">
                                Service
                            </Link>
                        </p>

                        <p onClick={productclick}>Product</p>

                        {/* ===== POLICY LINKS (CROSS PAGE SCROLL) ===== */}
                        <p>
                            <a  href="/privacy_policy.html#privacy-policy">
                                Privacy Policy
                            </a>
                        </p>

                        <p>
                            <a href="/terms_conditions.html">
                                Terms & Conditions
                            </a>
                        </p>

                        <p>
                            <a href="/privacy_policy.html#refund-cancellation">
                                Refund & Cancellation
                            </a>
                        </p>
                    </div>
                </div>

                {/* ================= SOCIAL LINKS ================= */}
                <div className="footer-social">
                    <div className="footer-social-instagram">
                        <a
                            href="https://www.instagram.com/AIZOPLUG"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i className="fa-brands fa-instagram"></i>
                        </a>
                    </div>

                    <div className="footer-social-twitter">
                        <a
                            href="https://x.com/aizoplug"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i className="fa-brands fa-x-twitter"></i>
                        </a>
                    </div>

                    <div className="footer-social-facebook">
                        <a
                            href="https://www.facebook.com/aizoplug"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i className="fa-brands fa-facebook-f"></i>
                        </a>
                    </div>
                </div>
            </div>

            {/* ================= COPYRIGHT ================= */}
            <div className="footer-copy">
                <p>
                    Copyright © {new Date().getFullYear()} All rights reserved |
                    AIZO PLUG SOLUTIONS PRIVATE LIMITED
                </p>
            </div>
        </div>
    );
};

export default Footer;
